import {Component, OnInit} from '@angular/core';
import {MemberModel} from '../../../models/user.model';
import {HelpersService} from '../../../services/helpers.service';
import {UserControlService} from '../user-control/user-control.service';
import {MemberService} from '../../../services/member.service';
import {AlertService} from '../../../services/notify/alert.service';
import {AuthService} from '../../../services/api/auth.service';
import {PaginationModel} from '../../../models/file-table.model';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ModalService} from '../../../services/modal/modal.service';
import {ModalSettingsModel} from '../../../models/modal.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-project-control-list',
    templateUrl: './persons-control-list.component.html',
    styleUrls: ['./persons-control-list.component.scss'],
})
export class PersonsControlListComponent implements OnInit {
    public userList: MemberModel[] = [];
    pagination: PaginationModel = new PaginationModel();

    isLockButton = false;
    isLockGroupButton = [];

    signs: { key: string, title: any }[];

    constructor(
        protected userControl: UserControlService,
        protected memberService: MemberService,
        public helper: HelpersService,
        public alert: AlertService,
        protected authService: AuthService,
        public modalService: ModalService,
        private translate: TranslateService,
    ) {
        this.signs = [
            {key: 'proj_admin', title: this.translate.instant('USER_PROFILE.ROLE.proj_admin')},
            {key: 'inner', title: this.translate.instant('USER_PROFILE.ROLE.inner')},
            {key: 'outer', title: this.translate.instant('USER_PROFILE.ROLE.outer')},
            {key: 'blocked', title: this.translate.instant('USER_PROFILE.ROLE.blocked')},
        ];
    }

    ngOnInit(): void {
        this.getUsers();
    }

    getUsers(): void {
        this.authService.getAllUsersWithPagination(this.pagination).subscribe(data => {
            this.userList = data.data.filter(x =>
                x.project_setting.observation_type !== 'blocked')
                .concat(data.data.filter(x => x.project_setting.observation_type === 'blocked'));
            this.pagination.pages = data.page_count;
        });
    }

    setPage(page: number): void {
        this.pagination.current_page = page;
        this.getUsers();
    }

    async deleteUser(user: MemberModel): Promise<any> {
        let modalSettings: ModalSettingsModel;
        modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.REMOVE_USER'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.isLockGroupButton[this.userList.indexOf(user)] = true;
                this.userControl.deleteUserFromProject(user.guid).then(_ => {
                    this.getUsers();
                    this.isLockGroupButton[this.userList.indexOf(user)] = false;
                });
            }
        }).catch(() => {
            return;
        });
    }

    async inviteUserInProject(mail: string, rules: string, comment: string, modal: NgbModalRef): Promise<any> {
        const valid = /^\S+@\S+\.\S+$/;
        if (!mail) {
            return this.alert.setAlert(this.translate.instant('ALERTS.ENTER_EMAIL'), 'blue');
        }
        if (!valid.test(mail)) {
            return this.alert.setAlert(this.translate.instant('ALERTS.EMAIL_ERROR'), 'blue');
        }
        if (!rules) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_PERMISSIONS'), 'blue');
        }

        this.isLockButton = true;

        const data = {
            email: mail,
            observ: rules,
            position: comment ? comment : null,
        };

        const result = await this.userControl.inviteUserInProject(data);
        if (result) {
            this.getUsers();
            this.isLockButton = false;
            modal.close();
        } else {
            this.isLockButton = false;
        }
    }

    async updateProjectAdmin(user: MemberModel, role: string): Promise<any> {
        const result = await this.userControl.updateProjectRights(user, role);
        if (result) {
            this.getUsers();
        }
    }

    checkRoles(user: MemberModel): void {
        this.signs = [
            {key: 'proj_admin', title: this.translate.instant('USER_PROFILE.ROLE.proj_admin')},
            {key: 'inner', title: this.translate.instant('USER_PROFILE.ROLE.inner')},
            {key: 'outer', title: this.translate.instant('USER_PROFILE.ROLE.outer')},
            {key: 'blocked', title: this.translate.instant('USER_PROFILE.ROLE.blocked')},
        ];

        this.signs = this.signs.filter(x => x.key !== user.project_setting.observation_type);

        if (user.project_setting.observation_type !== 'blocked') {
            this.signs.pop();
        }
    }

    setCustomTop(i: number): object {
        if (i === (this.userList.length - 1) || i === (this.userList.length - 2)) {
            return {top: '-100px'};
        }
    }
}
